import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M5.835 10.007c.5.06.856.51.796 1.007l-.034.296a133.95 133.95 0 0 0-.37 3.892c-.253 3.151-.404 6.31-.404 9.263 0 2.958.088 5.284.235 7.047.05.61.105 1.105.159 1.494.03.223.053.357.076.483.189 1.562 1.666 2.985 3.271 3.118.145.017.444.049.894.09.755.067 1.66.135 2.714.199 3.017.182 6.614.291 10.782.291 4.164 0 8.63-.169 13.097-.45a243.635 243.635 0 0 0 5.527-.413l.424-.039a.91.91 0 0 1 .994.817.908.908 0 0 1-.82.988l-.436.04c-.353.03-.762.065-1.222.102a236.4 236.4 0 0 1-4.351.313c-4.503.284-9.006.455-13.213.455-4.205 0-7.838-.11-10.892-.295a96.094 96.094 0 0 1-2.768-.204 50.068 50.068 0 0 1-.914-.09c-2.436-.202-4.604-2.291-4.885-4.632-.067-.327-.161-1.01-.253-2.117C4.09 29.846 4 27.47 4 24.465c0-3.008.154-6.212.41-9.406a135.732 135.732 0 0 1 .375-3.95l.036-.31a.91.91 0 0 1 1.014-.792Zm36.018.29a.903.903 0 0 1 .112 1.276l-7.941 9.402a2.566 2.566 0 0 1-3.804.165l-2.89-2.874c-.287-.285-.557-.248-.762.109L21.095 27.9a2.599 2.599 0 0 1-3.728.876l-2.422-1.606a.854.854 0 0 0-1.21.254l-3.591 5.713a.914.914 0 0 1-1.256.288.903.903 0 0 1-.29-1.249l3.59-5.713a2.683 2.683 0 0 1 3.768-.801l2.422 1.605c.405.269.892.155 1.135-.267l5.473-9.525c.8-1.391 2.493-1.623 3.633-.49l2.89 2.874a.738.738 0 0 0 1.12-.05l7.94-9.402a.915.915 0 0 1 1.284-.11Z"
    }
  )
);
var SvgStatsOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var StatsOutlined_default = SvgStatsOutlined;

export { StatsOutlined_default as default };
